import React from 'react';
import { Button } from './ui/button';

/**
 * "Next-Gen Mathematical Models" section: statistical accuracy panel on the left,
 * intro copy on the right (reversed order vs. the two adjacent sections).
 */
const FeatureNextGen = ({ t, pick }) => (
  <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
    <div className="grid md:grid-cols-2 gap-12 items-center">
      <div className="order-2 md:order-1 relative">
        <div className="bg-gradient-to-br from-blue-500/10 to-purple-500/10 backdrop-blur-sm border border-white/10 rounded-2xl p-8 shadow-2xl">
          <div className="space-y-4">
            <div className="flex justify-between items-center">
              <span className="text-white/60 text-sm">{t.features.nextGen.accuracy}</span>
              <span className="text-green-400 font-semibold">87.5%</span>
            </div>
            <div className="h-2 bg-white/10 rounded-full overflow-hidden">
              <div className="h-full w-[87.5%] bg-gradient-to-r from-green-400 to-emerald-500 rounded-full"></div>
            </div>

            <div className="mt-8 space-y-3">
              <RegimeCard
                label={t.features.nextGen.btcUsd}
                state={t.features.nextGen.bullish}
                stateColor="text-green-400"
                desc={t.features.nextGen.bullishDesc}
              />
              <RegimeCard
                label={t.features.nextGen.sp500}
                state={t.features.nextGen.neutral}
                stateColor="text-cyan-400"
                desc={t.features.nextGen.neutralDesc}
              />
            </div>
          </div>
        </div>
        <div className="absolute -inset-4 bg-gradient-to-r from-blue-500/20 to-purple-500/20 blur-3xl -z-10"></div>
      </div>

      <div className="order-1 md:order-2">
        <div className="inline-block px-4 py-2 bg-blue-500/10 border border-blue-500/30 rounded-full mb-6">
          <span className="text-blue-400 text-sm font-semibold">{pick('nextgen_badge')}</span>
        </div>
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
          {pick('nextgen_title1')}
          <br />
          {pick('nextgen_title2')}
        </h2>
        <p className="text-lg text-white/70 mb-8">{pick('nextgen_description')}</p>
        <Button size="lg" className="bg-white text-black hover:bg-white/90">
          {pick('nextgen_cta')}
        </Button>
      </div>
    </div>
  </section>
);

const RegimeCard = ({ label, state, stateColor, desc }) => (
  <div className="bg-white/5 border border-white/10 rounded-lg p-4">
    <div className="flex justify-between items-center">
      <span className="text-white font-medium">{label}</span>
      <span className={`${stateColor} font-semibold`}>{state}</span>
    </div>
    <p className="text-white/60 text-sm mt-2">{desc}</p>
  </div>
);

export default FeatureNextGen;
